import request from '../request';
import {RequestReturnPromise} from './type';

export type GetScheduleParams = {
  date: number | string;
};
export type ScheduleItem = {
  time: string;
  content: string;
  app: string;
  subTitle: string;
  path: string;
  logo: string;
  clickTo: number;
  params: any;
  fullTime: string;
  [property: string]: any;
};
export type GetScheduleData = {
  status: number;
  scheduleList: ScheduleItem[];
};

// 根据日期获取日程 /mp/one/pad/v1/schedule
export function getSchedule(
  data: GetScheduleParams,
): RequestReturnPromise<GetScheduleData> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/one/pad/v1/schedule',
    data,
  });
}
export type GetHomePageConfigData = {
  description: string;
  highLogo: string;
  id: number;
  logo: string;
  name: string;
  path: string;
  primaryLogo: string;
  sort: number;
  status: number;
  subTitle: string;
  clickTo: number;
  [property: string]: any;
};
// 获取页面配置 /mp/one/pad/v1/app/list/HomePage
export function getHomePageConfig(): RequestReturnPromise<
  GetHomePageConfigData[]
> {
  return request({
    method: 'get',
    url: '/api-internet-user/mp/one/pad/v1/app/list/Homepage',
  });
}

// 获取课程设置信息的请求参数类型
export type GetCurriculumSetupInfosParams = {
  termId: string;
  gradeId: string;
};

// 学期信息类型
export type Term = {
  id: string;
  name: string;
};

// 年级信息类型
export type Grade = {
  id: string;
  name: string;
};

// 学段信息类型
export type Stage = {
  id: number;
  name: string;
  grades: Grade[];
  courses: Course[];
};

// 获取课程设置信息的响应数据类型
export type GetCurriculumSetupInfosData = {
  terms: Term[];
  stages: Stage[];
};

// 获取课程设置信息的API函数
export function getCurriculumSetupInfos(): RequestReturnPromise<GetCurriculumSetupInfosData> {
  return request({
    method: 'get',
    url: '/api-answer-card/open/xkw/curriculumInfo/getCurriculumSetupInfos',
  });
}

// 更新 Course 类型定义
export type Version = {
  id: number;
  name: string;
};

export type Course = {
  id: number;
  name: string;
  subject_id: number;
  subject: {
    id: number;
    name: string;
  };
  versions: Version[]; // 添加版本数组
};

export interface GetForDiagnoseTestParams {
  /*年级ID */
  grade_id?: number;

  /*学科ID */
  subject_id?: number;

  /*学期枚举:NEXT,LAST,ALL */
  term?: string;

  /*试题知识点ID集合，最多传10个，超过的部分会被截取掉；如果传知识点父节点，也会搜索出其子节点中的试题 */
  kpoint_ids?: Record<string, unknown>[];

  /*章节ID集合，最多传10个，超过的部分会被截取掉；如果传章节父节点，也会搜索出子节点中的试题 */
  catalog_ids?: any[];

  /*试题难度等级ID集合（17 容易 18 较易 19 一般 20 较难 21 困难），最多传5个 */
  difficulty_levels?: Record<string, unknown>[];

  /*公式图片格式，支持两种：png或svg，默认是svg */
  formula_pic_format?: string;

  /*单词ID集合，最多传10个，超过的部分会被截取掉 */
  en_word_ids?: Record<string, unknown>[];
  textbook_id?: string;
  refillCountOfCatalogs?: number;
}
export type GetForDiagnoseTestData = {
  data: any[];
  session_id: string;
  generateRecordId: string;
};
// /api-answer-card/mp/xkw/questions/getForDiagnoseTest post
export function getForDiagnoseTest(
  data: GetForDiagnoseTestParams,
): RequestReturnPromise<GetForDiagnoseTestData> {
  return request({
    method: 'post',
    url: '/api-answer-card/mp/xkw/questions/getForDiagnoseTest',
    data,
  });
}

export type GetInitialTestAiCatalogRecommendParams = {
  subjectId: number;
  gradeId: number;
  term: string;
};
// /mp/one/pad/v1/xkw/initial/test/ai/catalog/recommend post
export function getInitialTestAiCatalogRecommend(
  data: GetInitialTestAiCatalogRecommendParams,
): RequestReturnPromise<Record<string, any>> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/one/pad/v1/xkw/initial/test/ai/catalog/recommend',
    data,
  });
}
export interface CollectUserBehaviorParams {
  code: string;
  useDuration: number;
  [property: string]: any;
}
// /mp/one/pad/user/behavior/collect post
export function collectUserBehavior(
  data: CollectUserBehaviorParams,
): RequestReturnPromise<Record<string, any>> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/one/pad/user/behavior/collect',
    data,
  });
}

// 获取关注二维码 /mp/one/pad/v1/schedule/v1/bind/device/qrcode
export function getBindDeviceQrcode(): RequestReturnPromise<string> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/one/pad/v1/bind/device/qrcode',
  });
}

export type HandleCurriculumSetupAlertParams = {
  handleType: 'keepGrade' | 'nextGrade' | 'nextTerm' | 'keepTerm' | 'nextStage';
  xkwStageId?: number;
  xkwGradeId?: number;
  xkwTerm?: string;
  xkwVersionList?: Array<{
    stage_id: number;
    subject_id: number;
    course_id: number;
    version_id: number;
  }>;
};
// 处理升年级、升学期提醒 /api-internet-user/mp/ai/user/handleCurriculumSetupAlert
export function fetchCurriculumSetupAlert(
  data: HandleCurriculumSetupAlertParams | undefined,
): RequestReturnPromise<Record<string, any>> {
  return request({
    method: 'post',
    url: `/api-internet-user/mp/ai/user/handleCurriculumSetupAlert?handleType=${data?.handleType}`,
  });
}
export type NextGradeInfo = {
  id: number;
  name: string;
  stageId: number;
  ordinalInStage: number;
  ordinalInAllStage: number;
};

// /api-internet-user/mp/ai/user/getNextGradeGoUpTo
export function fetchNextGradeInfo(): RequestReturnPromise<NextGradeInfo> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/getNextGradeGoUpTo',
  });
}

export type GetDiagnoseTestRecordParams = {
  term: string;
  gradeId: number;
  subjectId: number;
};
export type GetDiagnoseTestRecordData = {
  key: string;
  gradeId: number;
  subjectId: number;
  courseId: number;
  term: string;
  generateRecordId: string;
  completedTime: string;
};
// /api-answer-card/mp/xkw/user/generate/record/getDiagnoseTestRecord 获取诊断测评记录
export function getDiagnoseTestRecord(
  params: GetDiagnoseTestRecordParams,
): RequestReturnPromise<GetDiagnoseTestRecordData> {
  return request({
    method: 'get',
    url: '/api-answer-card/mp/xkw/user/generate/record/getDiagnoseTestRecord',
    params,
  });
}
